import { useState } from 'react';
import { CompetitionExerciseClient, CompetitionExerciseDTO, ApiResponse_string, SearchRequestDTO_CompetitionExerciseSearchRequestDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useCompetitionExerciseApi = () => {
    const apiClient = new CompetitionExerciseClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: CompetitionExerciseDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createCompetitionExercise(data);
        } catch (err: any) {
            setError(err.message || 'Error creating CompetitionExercise');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: CompetitionExerciseDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateCompetitionExercise(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating CompetitionExercise');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getCompetitionExerciseById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching CompetitionExercise');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchCompetitionExercises(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching CompetitionExercises');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteCompetitionExercise(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting CompetitionExercise');
        } finally {
            setIsLoading(false);
        }
    };

    const extract = async (
        filters: any
    ): Promise<ApiResponse_string> => {
        setIsLoading(true);
        try {
            return await apiClient.exportCompetitionExercises(filters);
        } catch (err: unknown) {
            handleHookError(err, 'Error exporting CompetitionExercises', setError);
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, extract, remove, isLoading, error };
};